import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid2,
  Stack,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useParams } from "react-router-dom";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { MdOutlineEdit } from "react-icons/md";
import {
  useGetAllNormsQuery,
  useUpdateNormsMutation,
} from "store/slices/apis/normsSlice";
import ProceedNormsActualDetail from "./ProceedActualDetail";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as EditIcon } from "assets/PwC_Funct_Icons_Edit_Outline_Black_RGB.svg"
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

const categories = [
  { label: "Fasade Concrete", year: 1994 },
  { label: "Fasade Plaster", year: 1972 },
  { label: "Mason Concrete", year: 1973 },
];

const AllNorms = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [pageNumber, setPageNumber] = useState(1);
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    category: "",
  });
  const [category, setCategory] = useState("");

  const { projectId } = useParams();
  const { data: allNormsList, isLoading } = useGetAllNormsQuery({
    ProjectId: projectId,
    category: filters?.category,
    page: pageNumber,
    pageSize: 10,
  });

  const [updateNorms, updateNormsRes] = useUpdateNormsMutation();

  const [actualValues, setActualValues] = useState([]);

  const handleAddFields = (rowId) => {
    let editFields = {
      id: rowId?.id,
      category: rowId?.category,
      qty: rowId?.qty,
      manpower: rowId?.manpower,
      projectId: rowId?.projectId,
      productivity: rowId?.productivity,
      uom: rowId?.uom,
    };
    setActualValues([...actualValues, editFields]);
  };

  const handleRemoveFields = (index) => {
    let result = [...actualValues];
    result.splice(index, 1);
    setActualValues(result);
  };

  const columns = [
    {
      name: "Category",
      field: "category",
    },
    {
      name: "Quantity",
      field: "qty",
      renderer: (params) => {
        let result = actualValues.map((a) => a.id);
        const isEditing = result?.includes(params.id);
        var index = result.indexOf(params.id);
        const currentValue = actualValues[index];

        if (isEditing) {
          const error = currentValue?.errors?.qty;
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                size="small"
                value={actualValues?.[index]?.qty}
                name="qty"
                onChange={(event) => handleFormChange(index, event)}
                error={error}
                helperText={error}
                inputProps={{
                  inputMode: "numeric",
                  max: 1000000,
                }}
                onInput={(event) => {
                  if (event.target.value.includes(".")) {
                    event.preventDefault();
                  }
                  const value = Number(event.target.value);
                  if (value > 1000000) {
                    event.target.value = 1000000;
                  }
                }}
              />
            </Stack>
          );
        }

        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <span>{params["qty"]}</span>
          </Stack>
        );
      },
    },

    {
      name: "Manpower",
      field: "manpower",
      renderer: (params) => {
        let result = actualValues.map((a) => a.id);
        const isEditing = result?.includes(params.id);
        var index = result.indexOf(params.id);

        const currentValue = actualValues[index];
        if (isEditing) {
          const error = currentValue?.errors?.manpower;
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                size="small"
                value={actualValues?.[index]?.manpower}
                name="manpower"
                onChange={(event) => handleFormChange(index, event)}
                error={error}
                helperText={error}
                inputProps={{
                  inputMode: "numeric",
                  max: 10000,
                }}
                onInput={(event) => {
                  if (event.target.value.includes(".")) {
                    event.preventDefault();
                  }
                  const value = Number(event.target.value);
                  if (value > 10000) {
                    event.target.value = 10000;
                  }
                }}
              />
            </Stack>
          );
        }

        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <span>{params["manpower"]}</span>
          </Stack>
        );
      },
    },
    {
      name: "U.O.M.",
      field: "uom",
      renderer: (params) => {
        let result = actualValues.map((a) => a.id);
        const isEditing = result?.includes(params.id);
        var index = result.indexOf(params.id);

        const currentValue = actualValues[index];
        if (isEditing) {
          const error = currentValue?.errors?.uom;
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                size="small"
                value={actualValues?.[index]?.uom}
                name="uom"
                onChange={(event) => handleFormChange(index, event)}
                error={error}
                helperText={error}
              />
            </Stack>
          );
        }

        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <span>{params["uom"]}</span>
          </Stack>
        );
      },
    },

    {
      name: "Productivity",
      field: "productivity",
    },
    {
      name: "Edit Action",
      renderer: (params) => {
        let result = actualValues.map((a) => a.id);
        const isEditing = result?.includes(params.id);
        var index = result.indexOf(params.id);
        if (isEditing) {
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                onClick={() => handleRemoveFields(index)}
                size="small"
                color="error"
                sx={{ padding: 0 }}
              >
                 {/* <IoMdClose style={{ fontSize: "large" }} /> */}
                <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px" }} />
              </IconButton>
            </Stack>
          );
        } else {
          return (
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                onClick={() => handleAddFields(params)}
                size="small"
                color="success"
                sx={{ padding: 0 }}
              >
                 {/* <MdOutlineEdit style={{ fontSize: "large" }} /> */}
                <EditIcon style={{ width: "20px", height: "20px" }} />
              </IconButton>
            </Stack>
          );
        }
      },
    },
  ];

  const handleValuesValid = () => {
    let isFormValid = true;
    actualValues?.map((val, index) => {
      Object.keys(val).forEach((x) => {
        if (x == "errors") {
          if (Object.keys(val[x]).length > 0) {
            return (isFormValid = false);
          }
        }
        if (!val[x]) {
          isFormValid = false;
        }
      });
    });
    return isFormValid;
  };

  const handleFormChange = (index, event) => {
    const { name, value } = event.target;

    if (name !== "uom" && !/^\d*$/.test(value)) {
      return;
    }

    setActualValues((prev) => {
      const updated = [...prev];
      const row = { ...updated[index] };

      row[name] = value;

      const errors = row.errors || {};

      if (!value) {
        errors[name] = "This field is required";
      } else if (name !== "uom" && isNaN(value)) {
        errors[name] = "Must be a number";
      } else {
        delete errors[name];
      }

      row.errors = errors;

      const qty = name === "qty" ? value : row.qty;
      const manpower = name === "manpower" ? value : row.manpower;

      if (!isNaN(qty) && !isNaN(manpower) && Number(manpower) !== 0) {
        row.productivity = Math.round(Number(qty) / Number(manpower));
      } else {
        row.productivity = "";
      }

      updated[index] = row;
      return updated;
    });
  };


  const handleProceedActual = () => {
    setOpen(true);
  };

  const handleApprove = () => {
    updateNorms({ body: actualValues }).unwrap();
  };
  const handleCancelProceedActual = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (updateNormsRes?.isSuccess) {
      if (updateNormsRes?.data?.status == "Success") {
        openNotification(updateNormsRes?.data?.message, "success");
      } else {
        openNotification(updateNormsRes?.data?.message, "success");
      }
      handleCancelProceedActual();
      setActualValues([]);
    }
  }, [updateNormsRes?.isSuccess]);

  useEffect(() => {
    if (updateNormsRes?.isError) {
      openNotification("something went problems!", "error");
    }
  }, [updateNormsRes?.isError]);

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <Autocomplete
                options={categories}
                getOptionLabel={(option) => option?.label}
                onChange={(_, newValue) =>
                  setCategory(newValue ? newValue?.label : "")
                }
                value={
                  categories?.find((option) => option.label === category) ||
                  null
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category"
                    name="currentStatus"
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "8px !important", // Remove wrapper padding
                      },
                    }}
                  />
                )}
                ListboxProps={{
                  sx: { fontSize: "13px" },
                }}
                sx={{
                  width: { xs: '100%', sm: '300px' },
                  // marginTop: "15px !important",
                }}
              />
              <Stack spacing={2} direction="row" sx={{ pt: '0px !important' }}>
                <Button
                  fullWidth
                  loading={isLoading}
                  onClick={() => {
                    setFilters({ category: category });
                    setActualValues([]);
                  }}
                  size="large"
                  startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill:`${theme?.customSettings?.themeColor}` }} />}
                  variant="outlined"
                  sx={{
                    color: `${theme?.customSettings?.themeColor}`,
                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                    background: "none",
                    textTransform: "inherit",
                    padding: "6px 15px",
                    // marginTop: "12px !important",
                  }}
                >
                  Search
                </Button>
                <Button
                  fullWidth
                  loading={isLoading}
                  onClick={() => {
                    setCategory("");
                    const clearedValues = Object.fromEntries(
                      Object.keys(filters).map((key) => [key, ""])
                    );
                    setFilters(clearedValues);
                    setActualValues([]);
                  }}
                  size="large"
                  variant="outlined"
                  sx={{
                    color: `${theme?.customSettings?.themeColor}`,
                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                    background: "none",
                    textTransform: "inherit",
                    padding: "6px 15px",
                    // marginTop: "12px !important",
                  }}
                >
                  Reset
                </Button>
              </Stack>
            </Stack>
            {actualValues?.length > 0 && (
              <Button
                variant="contained"
                // startIcon={<MdSaveAs sx={{ marginBottom: "2px" }} />}
                disabled={!handleValuesValid()}
                onClick={handleProceedActual}
                loading={updateNormsRes?.isLoading}
                sx={{
                  backgroundColor: `${theme?.customSettings?.themeColor}`,
                  color: "#FFF",
                  padding: "5px 20px",
                  fontWeight: "500",
                  textTransform: "none",
                  fontSize: "16px",
                  marginTop: "11px",
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  "&.Mui-disabled": {
                    border: "none",
                  },
                }}
              >
                Save
              </Button>
            )}
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent columns={columns} data={allNormsList?.data?.data} isLoading={isLoading} />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allNormsList?.data?.pagination?.currentPage || 1}
                totalPages={allNormsList?.data?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
      <ProceedNormsActualDetail
        open={open}
        cancel={handleCancelProceedActual}
        actualValues={actualValues}
        handleApprove={handleApprove}
        updateNormsRes={updateNormsRes}
      />
    </>
  );
};

export default AllNorms;
